import workspaceQuery from 'graphql/queries/customer/CustomerAttributeConfigWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/customer/CustomerAttributeConfigListQuery.graphql';
import instanceQuery from 'graphql/queries/customer/CustomerAttributeConfigQuery.graphql';
import defaultQuery from 'graphql/queries/customer/CustomerAttributeConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/customer/CustomerAttributeConfigMutation.graphql';
import fragment from 'graphql/fragments/customer/CustomerAttributeConfigFragment.graphql';

const CustomerAttributeConfig = {
  type: 'CustomerAttributeConfig',
  title: 'Customer Attributes',
  formTitle: 'Customer Attribute',
  formUrl: '/Customers/AttributeConfig/Details/',
  workspaceUrl: '/Customers/AttributeConfig/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  list: listQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
  },
  fragment,
  screenReference: 'CUSTOMER_ATTRIBUTES',
};

export default CustomerAttributeConfig;
